<template>
  <div>
    <div class="carousel-list">
      <div class="m-only flex justify-between items-center text-font-1">
        <div class="text-[18px] font-extrabold">{{ title }}</div>
      </div>
      <div class="pc-only carousel-list__title">
        {{ title }}
      </div>
    </div>
    <div v-if="total" class="relative">
      <!-- 左侧前进按钮 -->
      <SwitchBtn
        class="pc-only x-button-prev"
        @click="handlePrev"
        variant="grey-large"
        type="prev"
        :disabled="!hasPrevPage"
      />

      <Swiper
        class="mt-[20px]"
        :slidesPerView="1"
        :slidesPerGroup="1"
        :spaceBetween="16"
        :pagination="true"
        :modules="[Pagination]"
        :breakpoints="{
          680: {
            slidesPerView: props.slidesPerView,
            slidesPerGroup: props.slidesPerView,
            pagination: false,
            modules: [],
          },
        }"
        @swiper="onSwiper"
      >
        <slot />
      </Swiper>

      <!-- 右侧后退按钮 -->
      <SwitchBtn
        class="pc-only x-button-next"
        variant="grey-large"
        type="next"
        @click="handleNext"
        :disabled="!hasNextPage"
      />
    </div>
    <slot v-else-if="!isMobile" name="empty" />
  </div>
</template>
<script lang="ts" setup>
import SwitchBtn from '@/design/components/buttons/switch-btn.vue';
import { Pagination } from 'swiper/modules';
import { Swiper } from 'swiper/vue';

const { isMobile } = useDevice();

interface CarouselListProps {
  title: string;
  total: number;
  slidesPerView?: number;
}

const props = withDefaults(defineProps<CarouselListProps>(), {
  slidesPerView: 4,
});

const swiper = ref();

function onSwiper(_swiper: any) {
  swiper.value = _swiper;
}

const totalPage = computed(() => {
  return Math.ceil(props.total / props.slidesPerView);
});

const hasPrevPage = computed(() => {
  return swiper.value?.activeIndex > 0;
});

const hasNextPage = computed(() => {
  if (!swiper.value) return false;
  // 直接使用 Swiper 的 isEnd 属性，或者计算当前索引是否已经到达最后
  return !swiper.value.isEnd;
  // return (
  //   Math.ceil((swiper.value?.activeIndex + 1) / props.slidesPerView) <
  //   totalPage.value
  // )
});

function handlePrev() {
  swiper.value.slidePrev();
}

function handleNext() {
  swiper.value.slideNext();
}
</script>
<style lang="scss" scoped>
.carousel-list__title {
  @apply flex-center;
  color: var(--x-text-1);
  font-size: 400;
  font-style: normal;
  line-height: normal;
  font-size: 48px;
  margin-bottom: 80px;
}
:deep(.swiper-slide) {
  padding-bottom: 30px;
}

.x-button-prev {
  @apply absolute left-[-86px] top-1/2 transform -translate-y-1/2 z-10;
}

.x-button-next {
  @apply absolute right-[-86px] top-1/2 transform -translate-y-1/2 z-10;
}
</style>
